export enum Theme {
	GREEN = 'green',
	BLUE = 'blue',
	RED = 'red',
	DISABLED = 'disabled',
	ORANGE = 'orange',
	GREY = 'grey',
	WHITE = 'white',
}
